import tabbable from 'tabbable';

const TAB_KEY = 9;

/** @type {HTMLElement} */
let currentContainer = null;

/** @type {HTMLElement[]} */
let currentTabbable = [];

let mutationObserver = new MutationObserver(() => {
   currentContainer.addEventListener('transitionend', () => {
      updateTabbable();
   }, { once: true });

   updateTabbable();
});

/** @param {HTMLElement} el */
export function blockFocusInside(el) {
   currentContainer = el;

   mutationObserver.observe(el, {
      attributes: true,
      childList: true,
      subtree: true,
   });
   
   updateTabbable();
   
   if (!currentTabbable.includes(document.activeElement)) {
      focusFirst();
   }

   document.addEventListener('keydown', onPress);
}

export function unblockFocus() {
   if (!currentContainer) return;

   document.removeEventListener('keydown', onPress);
   currentContainer = null;
   currentTabbable = [];

   mutationObserver.disconnect();
}

/** @param {KeyboardEvent} event */
function onPress(event) {
   if (event.keyCode !== TAB_KEY) return;
   
   if (currentTabbable.length <= 1) {
      event.preventDefault();
      return;
   }

   const firstTabbable = currentTabbable[0];
   const lastTabbable = currentTabbable[currentTabbable.length - 1];
   const active = document.activeElement;

   if (!currentTabbable.includes(active)) {
      focusFirst();
      return;
   }

   if (event.shiftKey) {
      if (active !== firstTabbable) return;
      event.preventDefault();
      lastTabbable.focus();

   } else {
      if (active !== lastTabbable) return;
      event.preventDefault();
      firstTabbable.focus();
   }
}

function focusFirst() {
   if (!currentTabbable.length) return;
   currentTabbable[0].focus();

   currentContainer.addEventListener('transitionend', () => {
      if (!currentTabbable.length) return;
      currentTabbable[0].focus();
   }, { once: true });
}

function updateTabbable() {
   if (!currentContainer) return;
   currentTabbable = tabbable(currentContainer, {
      includeContainer: true,
   });
}